// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","732":"93908cc3","977":"4db89900"}[chunkId] + ".chunk.js";
};